import { render, staticRenderFns } from "./DocumentoIdentidad.vue?vue&type=template&id=0ea92fc0"
import script from "./DocumentoIdentidad.vue?vue&type=script&lang=ts"
export * from "./DocumentoIdentidad.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports